import { listStyles } from "@dana/Overrides/Widgets/ProductList/ProductListCardList";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

listStyles.wrapper = mergeToNew(listStyles.wrapper, {
    css: css`
        margin-top: 24px;
        border-top: none;
    `,
});

listStyles.cardList = mergeToNew(listStyles.cardList, {
    gridContainer: {
        gap: 16,
    },
});

listStyles.cardContainerStyles = mergeToNew(listStyles.cardContainerStyles, {
    cardDivider: {
        css: css`
            margin: 0;
            border-bottom: none;
        `,
    },
});

listStyles.cardContainerMultiColumnStyles = mergeToNew(listStyles.cardContainerMultiColumnStyles, {
    gridItem: {
        css: css`
            @media only screen and (max-width: 1100px) {
                flex-basis: 50%;
                max-width: 50%;
            }

            @media only screen and (max-width: 545px) {
                flex-basis: 100%;
                max-width: 100%;
            }
        `,
    },
});
